import React from "react";
import { useNavigate } from "react-router-dom";
import LogoImgClient from "../../assets/icons/Logo2.png";
import LogoImgTasker from "../../assets/icons/Logo3.png";

// Import Social Icons
import facebookIcon from "../../assets/icons/facebook.svg";
import instagramIcon from "../../assets/icons/instagram.svg";
import twitterIcon from "../../assets/landing/twitter.svg";
import youtubeIcon from "../../assets/icons/youtube.svg";
import { useSelector } from "react-redux";
import { roles } from "../../constants/commonConstants";
import addressIcon from "../../assets/icons/Address.svg";
import phoneIcon from "../../assets/icons/phone.svg";
import { ReactComponent as WaIcon } from "../../assets/icons/whatsapp-white.svg";
import { ReactComponent as EmailIcon } from "../../assets/icons/email.svg";
// import { ReactComponent as PhoneCallIcon } from "../../assets/icons/whatsapp.svg";
// import { ReactComponent as EmailMultipleIcon } from "../../assets/icons/email-multiple.svg";

const Footer = () => {
  const { isAuthenticated, user, role } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const handleNavigation = (link) => {
    navigate(link);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const menuItems1 = [
    { text: "About Us", link: "/about" },
    { text: "Contact Us", link: "/contact" },
    // { text: "FAQ", link: role === roles.USER ? "/client" : "/service-pro" },
  ];

  const menuItems2 = [
    {
      text: "How It works",
      link: role === roles.USER ? "/client" : "/service-pro",
    },
    { text: "Find a Tasker", link: "/client/find-service-pro" },
    { text: "Post a Job", link: "/client/post-job" },
  ];

  const menuItems3 = [
    // { text: "No 01. ABC Road, Colombo 01", icon: addressIcon },
    { text: "+233271752953", icon: WaIcon },
    { text: "support@jumaconnect.com", icon: EmailIcon },
  ];

  const socialIcons = [
    // {
    //   icon: youtubeIcon,
    //   alt: "youtube",
    // },
    {
      icon: facebookIcon,
      alt: "facebook",
      link: "https://www.facebook.com/share/1EP2UyRvUZ/?mibextid=wwXIfr",
    },
    {
      icon: twitterIcon,
      alt: "twitter",
      link: "https://x.com/jumaconnect",
    },
    {
      icon: instagramIcon,
      alt: "instagram",
      link: "https://www.instagram.com/jumaconnect/#",
    },
  ];

  return (
    <footer
      style={{ backgroundColor: "var(--footer-theme)", width: "100%" }}
      className="px-[16px] md:px-[60px] lg:px-[120px]"
    >
      <div className="px-4 pt-12 pb-4">
        {/* Top Section */}
        <div className="flex flex-col xl:flex-row justify-between items-start xl:items-center">
          {/* Navigation Menu */}
          <div className=" flex flex-col p-2.5 space-y-6">
            {/* Logo */}
            <div className="w-[148px]">
              <img
                src={LogoImgTasker}
                alt="JumaConnect Logo"
                className="w-full h-auto"
              />
            </div>
            <div>
              <h1 className="font-inter text-[14px] text-white max-w-[284px]">
                Whether you need someone for a quick task or a long-term project, we connect you with skilled professionals.
              </h1>
            </div>
            {/* Social Icons */}
            <div className="flex gap-4">
              {socialIcons.map((social, index) => (
                <a href={social?.link} target="_blank">
                  <img
                    key={index}
                    src={social.icon}
                    alt={social.alt}
                    className="w-6 h-6 cursor-pointer hover:opacity-80"
                  />
                </a>
              ))}
            </div>
          </div>

          <div className=" flex flex-col sm:flex-row justify-between w-full  mt-10 xl:mt-0 xl:w-2/3">
            {/* Navigation Menu */}
            <div className="flex flex-col  justify-between xs:flex-row xs:space-x-10 w-[80%] xs:w-[75%] sm:w-[50%]">
              {/* Navigation Menu */}
              <div className="flex flex-col flex-wrap justify-start gap-4 items-start">
                <h1 className="font-inter text-white text-level-5 font-semibold mb-4 ">
                  Company
                </h1>
                {menuItems1.map((item, index) => (
                  <button
                    key={index}
                    className=" py-0 text-white hover:opacity-80 font-inter font-medium text-sm"
                    onClick={() => handleNavigation(item.link)}
                  >
                    {item.text}
                  </button>
                ))}
              </div>

              {/* Navigation Menu */}
              <div className="flex flex-col mt-10 xs:mt-0 flex-wrap justify-start gap-4 items-start">
                <h1 className="font-inter text-white text-level-5 font-semibold mb-4">
                  Services
                </h1>
                {menuItems2.map((item, index) => (
                  <button
                    key={index}
                    className=" py-0 text-white hover:opacity-80 font-inter font-medium text-sm"
                    onClick={() => handleNavigation(item.link)}
                  >
                    {item.text}
                  </button>
                ))}
              </div>
            </div>

            {/* Navigation Menu */}
            <div className="flex flex-col mt-10 sm:mt-0 flex-wrap justify-start gap-4 items-start ">
              <h1 className="font-inter text-white text-level-5 font-semibold mb-4">
                Reach Us
              </h1>
              {menuItems3.map((item, index) => {
                const isEmail = item.text.includes("@");
                const isPhone = /^\+?[0-9\s-]+$/.test(item.text);

                return (
                  <div
                    key={index}
                    className=" py-0 text-white hover:opacity-80 font-inter font-medium text-sm text-start"
                  >
                    <div className="flex flex-row items-center">
                      {/* <img
                        src={item.icon}
                        alt={item.alt}
                        className="w-6 h-6 cursor-pointer hover:opacity-80 mr-4 "
                      /> */}
                      <item.icon className="w-6 h-6 cursor-pointer hover:opacity-80 mr-4"/>
                      {isEmail ? (
                        <a
                          href={`mailto:${item.text}`}
                          className="hover:underline"
                        >
                          {item.text}
                        </a>
                      ) : isPhone ? (
                        <a
                          href={`tel:${item.text.replace(/\s+/g, "")}`}
                          className="hover:underline"
                        >
                          {item.text}
                        </a>
                      ) : (
                        <span>{item.text}</span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-[1px] bg-[#CBD5E0] my-4" />

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-white opacity-70 font-inter font-medium text-sm">
            JumaConnect @ 2025. All rights reserved.
          </p>

          <div className="flex flex-row space-x-4">
            <button
              className="text-white opacity-70 font-inter font-medium text-sm hover:opacity-80"
              onClick={() => handleNavigation("/terms-and-condition")}
            >
              Terms & Conditions{" "}
            </button>

            <button
              className="text-white opacity-70 font-inter font-medium text-sm hover:opacity-80"
              onClick={() => handleNavigation("/privacy-policise")}
            >
              Privacy Policy{" "}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
